import { useEffect, useLayoutEffect } from "react";
import { useLocation } from "react-router-dom";
import { resetScroll, preventScrollRestoration } from "../utils/scrollHelper";

/**
 * ScrollToTop component
 * 
 * This component scrolls the window to the top whenever the route changes.
 * Uses multiple approaches to ensure maximum browser compatibility.
 */
function ScrollToTop() {
    const { pathname } = useLocation();

    // Run once on component mount to prevent browser from restoring scroll
    useEffect(() => {
        preventScrollRestoration();
    }, []);

    // useLayoutEffect runs synchronously before browser paint
    useLayoutEffect(() => {
        resetScroll();
    }, [pathname]);

    // useEffect as a backup to ensure it works
    useEffect(() => {
        // Set a small timeout to ensure the scroll happens after any DOM updates
        const timeoutId = setTimeout(() => {
            resetScroll();
        }, 0);

        return () => clearTimeout(timeoutId);
    }, [pathname]);

    return null;
}

export default ScrollToTop; 